module.exports = __webpack_public_path__ + "static/media/dots.9600b6e8.svg";